import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Anchor, Loader2 } from "lucide-react";

export default function PortalLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    if (!res.ok) {
      setError(res.error || "Unable to sign in.");
      setBusy(false);
      return;
    }
    if (res.user?.role !== "owner") {
      setError("This sign-in is for vessel owners. Please use the staff sign-in.");
      setBusy(false);
      return;
    }
    const from = location.state?.from;
    navigate(from && from.startsWith("/") ? from : "/portal", { replace: true });
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#051329] px-5" data-testid="portal-login-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 text-[#D4AF37] tracking-[0.3em] text-xs mb-2">
          <Anchor className="h-4 w-4" /> HUSSAR MARINE CONCIERGE
        </div>
        <h1 className="text-white text-2xl font-light mb-1">Owner Portal</h1>
        <p className="text-slate-400 text-sm mb-7">Your vessel's documented oversight history.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="portal-login-form">
          <input
            data-testid="portal-login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full rounded-lg bg-[#0b1f3a] border border-[#1e3a5f] px-4 py-3 text-white placeholder-slate-500 focus:border-[#D4AF37] outline-none"
          />
          <input
            data-testid="portal-login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full rounded-lg bg-[#0b1f3a] border border-[#1e3a5f] px-4 py-3 text-white placeholder-slate-500 focus:border-[#D4AF37] outline-none"
          />
          {error && (
            <p data-testid="portal-login-error" className="text-red-400 text-sm">{error}</p>
          )}
          <button
            data-testid="portal-login-submit"
            type="submit"
            disabled={busy}
            className="w-full rounded-lg bg-[#D4AF37] text-[#051329] font-medium py-3 flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
